<template>
  <div>
    <f7-block inset v-if="enableBlockNumber">
      <f7-segmented raised strong>
        <f7-button :active="tab_config === 'chung'" @click.prevent="tab_config = 'chung'">
          CÀI ĐẶT CHUNG
        </f7-button>
        <f7-button :active="tab_config === 'so-ket'" @click.prevent="tab_config = 'so-ket'">
          CHẶN SỐ KẸT
        </f7-button>
      </f7-segmented>
    </f7-block>
    <template v-if="tab_config === 'chung'">
      <f7-block inset strong>
        <p>
          <label class="mr-1">
            <f7-radio name="type_input_over_config" value="all" @change="type_input_over_config = 'all'" :checked="type_input_over_config === 'all'"></f7-radio>
            Tất cả
          </label>
          <label class="mr-1">
            <f7-radio name="type_input_over_config" value="detail" @change="type_input_over_config = 'detail'" :checked="type_input_over_config === 'detail'"></f7-radio>
            Chi tiết
          </label>
        </p>
      </f7-block>
      <template v-if="type_input_over_config === 'all' && !_.isEmpty(over_point_config.general_overpoint)">
        <f7-block strong>
          <f7-block-title class="margin-first">2C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_dau"
                  @input="changeAllConfig('2c', 'over_point_dau', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_duoi"
                  @input="changeAllConfig('2c', 'over_point_duoi', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_bao"
                  @input="changeAllConfig('2c', 'over_point_bao', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="this.region === 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="8Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_tamlo"
                  @input="changeAllConfig('2c', 'over_point_tamlo', $event.target.value)">
                </f7-list-input>
              </f7-list>
              <f7-list class="mt-0 mb-0 no-border" v-else-if="this.region !== 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_baylo"
                  @input="changeAllConfig('2c', 'over_point_baylo', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">3C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['3c'].over_point_dau"
                  @input="changeAllConfig('3c', 'over_point_dau', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['3c'].over_point_duoi"
                  @input="changeAllConfig('3c', 'over_point_duoi', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['3c'].over_point_bao"
                  @input="changeAllConfig('3c', 'over_point_bao', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['3c'].over_point_baylo"
                  @input="changeAllConfig('3c', 'over_point_baylo', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">4C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['4c'].over_point_bao"
                  @input="changeAllConfig('4c', 'over_point_bao', $event.target.value), changeAllConfig('4c', 'over_point_baylo', $event.target.value), changeAllConfig('4c', 'over_point_duoi', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">ĐáT</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đá Thẳng"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_da"
                  @input="changeAllConfig('da', 'over_point_da', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <template v-if="region !== 'mb'">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="Đá Xiên"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[this.region][detail_tab][first_channel]['2c'].over_point_dx"
                    @input="changeAllConfig('dx', 'over_point_dx', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
          <template v-else-if="region === 'mb' && selected_customer.config_deal.mb.dx_style === 2">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX2 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[this.region][detail_tab]['mb']['2c'].over_point_dx_2"
                    @input="changeAllConfig('dx', 'over_point_dx_2', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX3 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[this.region][detail_tab]['mb']['2c'].over_point_dx_3"
                    @input="changeAllConfig('dx', 'over_point_dx_3', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX4 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[this.region][detail_tab]['mb']['2c'].over_point_dx_4"
                    @input="changeAllConfig('dx', 'over_point_dx_4', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
        </f7-block>
        <f7-row class="mt-2 mb-2">
          <f7-col>
            <f7-button fill color="primary" @click.prevent="updateOverPointConfig">LƯU</f7-button>
          </f7-col>
        </f7-row>
      </template>
      <template v-if="type_input_over_config === 'detail' && !_.isEmpty(over_point_config.general_overpoint)">
        <f7-block inset>
          <f7-segmented raised strong>
            <f7-button :active="detail_tab === 'monday'" @click.prevent="detail_tab = 'monday'">
              T2
            </f7-button>
            <f7-button :active="detail_tab === 'tuesday'" @click.prevent="detail_tab = 'tuesday'">
              T3
            </f7-button>
            <f7-button :active="detail_tab === 'wednesday'" @click.prevent="detail_tab = 'wednesday'">
              T4
            </f7-button>
            <f7-button :active="detail_tab === 'thursday'" @click.prevent="detail_tab = 'thursday'">
              T5
            </f7-button>
            <f7-button :active="detail_tab === 'friday'" @click.prevent="detail_tab = 'friday'">
              T6
            </f7-button>
            <f7-button :active="detail_tab === 'saturday'" @click.prevent="detail_tab = 'saturday'">
              T7
            </f7-button>
            <f7-button :active="detail_tab === 'sunday'" @click.prevent="detail_tab = 'sunday'">
              CN
            </f7-button>
          </f7-segmented>
        </f7-block>
        <f7-block strong>
          <f7-block-title class="margin-first pt-2 mb-0">2C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="this.region === 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="8Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_tamlo"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_tamlo = $event.target.value">
                </f7-list-input>
              </f7-list>
              <f7-list class="mt-0 mb-0 no-border" v-else-if="this.region !== 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp3])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">3C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp3])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">4C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['4c'].over_point_bao = $event.target.value, over_point_config.general_overpoint[region][detail_tab]['mb']['4c'].over_point_baylo = $event.target.value, over_point_config.general_overpoint[region][detail_tab]['mb']['4c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['4c'].over_point_bao = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['4c'].over_point_bao = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['4c'].over_point_bao = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp3])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['4c'].over_point_bao = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">ĐáT</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="MB"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_da = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <template v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab]['mb'])">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX2 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_2"
                    @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_2 = $event.target.value">
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX3 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_3"
                    @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_3 = $event.target.value">
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX4 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_4"
                    @input="over_point_config.general_overpoint[region][detail_tab]['mb']['2c'].over_point_dx_4 = $event.target.value">
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][detail_tab][dc]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp2]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp3])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][detail_tab][dp3]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <template v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dc])">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp2.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp2]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp2]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp2])">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp.toUpperCase() + ` ` + dp2.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dp + '_' + dp2]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dp + '_' + dp2]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
            <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][detail_tab][dp3])">
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dc + '_' + dp3]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dp + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dp + '_' + dp3]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp2.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][detail_tab][dp2 + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][detail_tab][dp2 + '_' + dp3]['2c'].over_point_dx = $event.target.value"
                  >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
        </f7-block>
        <f7-row class="mt-2 mb-2">
          <f7-col>
            <f7-button fill color="primary" @click.prevent="updateOverPointConfig">LƯU</f7-button>
          </f7-col>
        </f7-row>
      </template>
    </template>
    <template v-else-if="tab_config === 'so-ket'">
      <f7-row>
        <f7-col></f7-col>
        <f7-col>
          <f7-block-title class="mt-0 mb-0 text-align-right text-color-crimson">
            <f7-link @click.prevent="popupNumbers = true">
              <f7-icon size="18px" ios="f7:plus"></f7-icon>
              Thêm mới
            </f7-link>
          </f7-block-title>
        </f7-col>
      </f7-row>
      <f7-block v-if="popupNumbers" inset strong class="mt-0">
        <div class="data-table sm bordered bold-bordered">
          <table>
            <tbody>
            <tr>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('monday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('monday')">
                T2
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('tuesday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('tuesday')">
                T3
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('wednesday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('wednesday')">
                T4
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('thursday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('thursday')">
                T5
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('friday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('friday')">
                T6
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('saturday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('saturday')">
                T7
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.indexOf('sunday') >= 0}" @click.prevent="toggleFormBlockNumbersWeekday('sunday')">
                CN
              </td>
              <td class="text-align-center" :class="{'number-selected': form_block_numbers.week_day.length === 7}" @click.prevent="toggleFormBlockNumbersAllday">
                ALL
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <f7-list class="mb-1">
          <f7-list-input
            label="SỐ KẸT"
            type="textarea"
            placeholder="Nhập nội dung"
            :value="form_block_numbers.content"
            @input="form_block_numbers.content = $event.target.value"
          >
          </f7-list-input>
        </f7-list>
        <f7-row>
          <f7-col>
            <f7-button fill round small color="gray" @click.prevent="popupNumbers = false">
              Hủy
            </f7-button>
          </f7-col>
          <f7-col>
            <f7-button fill round small @click.prevent="submitFormBlockNumbers">
              Lưu
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
      <template v-if="block_numbers.length">
        <div class="data-table sm bordered card pt-1" v-for="(item, idx) in block_numbers" :key="idx">
          <table>
            <tr>
              <td>
                <f7-row no-gap>
                  <f7-col width="70">
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('monday') >= 0" text="T2" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('tuesday') >= 0" text="T3" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('wednesday') >= 0" text="T4" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('thursday') >= 0" text="T5" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('friday') >= 0" text="T6" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('saturday') >= 0" text="T7" color="red"></f7-chip>
                    <f7-chip class="text-sm" v-if="item.content_json.weekdays.indexOf('sunday') >= 0" text="CN" color="red"></f7-chip>
                  </f7-col>
                  <f7-col class="text-align-right">
                    <f7-link class="margin-left-half" @click.prevent="$copyText(item.content.trim())">
                      <f7-icon size="16" f7="doc_on_doc"></f7-icon>
                    </f7-link>
                    <f7-link class="margin-left-half" @click.prevent="deleteBlockNumbers(idx)">
                      <f7-icon size="16" f7="trash"></f7-icon>
                    </f7-link>
                  </f7-col>
                </f7-row>
              </td>
            </tr>
            <tr>
              <td class="pt-1">{{ item.content }}</td>
            </tr>
          </table>
        </div>
      </template>
      <p v-else class="text-align-center">Chưa thiết lập</p>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2">
        <p>Bấm chọn <b class="text-color-red">+Thêm mới</b> để thiết lập</p>
        <p>Lưu ý:</p>
        <ul>
          <li>Tin nhắn nhập vào sẽ được bot nhận theo đúng số tiền bạn nhập Ví dụ : 3d 38 78 39 79 b 50n dd 50n da 20n
              ---> thì bot sẽ nhận tương ứng cách chơi blo 50n , dd 50n , đá xiên 20n ở từng con số và cặp đá.
          </li>
          <li>Bạn có thể nhập tin nhắn từng ngày hoặc chọn áp dụng cho tất cả các ngày, khi đó tin nhắn nhập vô sẽ là 2d
              3d 4d dc dp. Trường hợp bạn nhập 4d ( miền nam ) 3d ( miền trung ) và bấm chọn áp dụng cho tất cả các
              ngày. Thì bot sẽ hiểu những ngày khác là 3d và 2d
          </li>
          <li>Không nhận số trùng nếu bạn đã cài đặt trước đó, vui lòng xoá cài đặt dãy số cũ để cài lại.</li>
        </ul>
      </f7-block>
    </template>
  </div>
</template>
<style scoped>
.text-sm {
  font-size : 0.8em;
  height    : 18px;
}
.data-table.bold-bordered {
  border : 1px solid #000000;
}
.data-table tr td.number-selected {
  color      : #FFFFFF;
  background : #77001C;
}
</style>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    region: String,
    playStyle: String,
    custId: String,
    enableBlockNumber: Boolean
  },
  data() {
    return {
      tab_config: 'chung',
      type_input_over_config: 'all',
      detail_tab: 'monday',
      filter_channel_options: {
        mb: {
          monday: {
            mb: 'mb'
          },
          tuesday: {
            mb: 'mb'
          },
          wednesday: {
            mb: 'mb'
          },
          thursday: {
            mb: 'mb'
          },
          friday: {
            mb: 'mb'
          },
          saturday: {
            mb: 'mb'
          },
          sunday: {
            mb: 'mb'
          },
        },
        mn: {
          monday: {
            dc: 'tp',
            dp: 'dt',
            dp2: 'cm'
          },
          tuesday: {
            dc: 'bt',
            dp: 'vt',
            dp2: 'bl'
          },
          wednesday: {
            dc: 'dn',
            dp: 'ct',
            dp2: 'st'
          },
          thursday: {
            dc: 'tn',
            dp: 'ag',
            dp2: 'bt'
          },
          friday: {
            dc: 'vl',
            dp: 'bd',
            dp2: 'tv'
          },
          saturday: {
            dc: 'tp',
            dp: 'la',
            dp2: 'bp',
            dp3: 'hg'
          },
          sunday: {
            dc: 'tg',
            dp: 'kg',
            dp2: 'dl'
          },
        },
        mt: {
          monday: {
            dc: 'py',
            dp: 'th'
          },
          tuesday: {
            dc: 'dl',
            dp: 'qn'
          },
          wednesday: {
            dc: 'dn',
            dp: 'kh'
          },
          thursday: {
            dc: 'bd',
            dp: 'qt',
            dp2: 'qb'
          },
          friday: {
            dc: 'gl',
            dp: 'nt'
          },
          saturday: {
            dc: 'dn',
            dp: 'qn',
            dp2: 'dno'
          },
          sunday: {
            dc: 'kt',
            dp: 'kh',
            dp2: 'th'
          },
        }
      },
      tab_region_block_number: 'mn',
      form_block_numbers: {
        content: "",
        week_day: [],
        region: "",
        play_style: "",
        type: 1,
        customer_id: 0,
        apply_all_days: 0
      },
      template_block_numbers: {
        id: 0,
        customer_scope: 2,
        customers: [],
        config_channel: {
          mb: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
          },
          mn: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
          },
          mt: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
          }
        },
        config_command: ['baolo', 'dd'],
        numbers: '',
        number_types: ['2c', '3c'],
        apply_type: 1,
        quota: 1000,
        apply_till_date: null,
        is_changed: 1,
      },
      block_numbers: [],
      popupNumbers: false
    }
  },
  computed: {
    ...mapState(['selected_customer', 'selected_drawdate', 'user_info', 'customers', 'friends']),
    first_channel() {
      let real_region = this.region;
      if (this.playStyle === 'mb_ngan') {
        real_region = 'mb_ngan';
      }
      return Object.keys(this.over_point_config.general_overpoint[real_region][this.detail_tab])[0];
    },
    dc() {
      return this.filter_channel_options[this.region][this.detail_tab].dc;
    },
    dp() {
      return this.filter_channel_options[this.region][this.detail_tab].dp;
    },
    dp2() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.detail_tab].dp2)) ? '' : this.filter_channel_options[this.region][this.detail_tab].dp2;
    },
    dp3() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.detail_tab].dp3)) ? '' : this.filter_channel_options[this.region][this.detail_tab].dp3;
    },
    over_point_config() {
      return {
        number_overpoint: {},
        general_overpoint: this.selected_customer.over_point_config
      };
    }
  },
  methods: {
    toggleFormBlockNumbersWeekday(name) {
      let idx = this.form_block_numbers.week_day.indexOf(name);
      if (idx >= 0) {
        this.form_block_numbers.week_day.splice(idx, 1);
      }
      else{
        this.form_block_numbers.week_day.push(name);
      }
    },
    toggleFormBlockNumbersAllday() {
      if (this.form_block_numbers.week_day.length !== 7) {
        this.form_block_numbers.week_day = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      }
      else{
        this.form_block_numbers.week_day = [];
      }
    },
    getBlockNumbers() {
      const self = this;
      if (!self.enableBlockNumber) {
        return false;
      }
      self.$store.dispatch('getBlockNumbers', {
        region: self.region,
        play_style: self.playStyle,
        customer_id: self.custId,
        type: 1,
      }).then((data) => {
        self.block_numbers = data;
      }).catch((err) => {
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    async submitFormBlockNumbers() {
      const self = this;
      self.$f7.dialog.preloader();

      if (self.form_block_numbers.content === '') {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Vui lòng nhập nội dung', 'LỖI!');
        return false;
      }

      if (self.form_block_numbers.week_day.length === 0) {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Vui lòng chọn ít nhất 1 ngày trong tuần', 'LỖI!');
        return false;
      }

      try{
        await self.$store.dispatch('createBlockNumbers', self.form_block_numbers);

        self.popupNumbers = false;
        self.form_block_numbers.week_day = [];
        self.form_block_numbers.content = '';

        self.$f7.dialog.close();
        setTimeout(function() {
          self.getBlockNumbers();
        }, 200);
      }catch(err){
        self.$f7.dialog.close();
        if (self._.isString(err)) {
          self.$f7.dialog.alert('Lỗi', 'LỖI!');
        }
        else if (self._.isArray(err)) {
          for(let i in err){
            let msg = err[i][1]['message'];
            if (msg.length > 200) {
              msg = msg.substring(0, 200).replace(/\n/g, '<br/>') + '...';
            }
            self.$f7.dialog.alert(err[i][1]['error'] + '<br/>' + msg, 'LỖI!');
            break;
          }
        }
        else{
          self.$f7.dialog.alert('Có lỗi xảy ra', 'LỖI!');
        }
      }
    },
    deleteBlockNumbers(idx) {
      const self = this;
      self.$f7.dialog.confirm('Bạn chắc chắn muốn xóa thiết lập này?', 'CẢNH BÁO!', () => {
        if (!self.block_numbers[idx].id) {
          self.block_numbers.splice(idx, 1);
        }
        else{
          self.$f7.preloader.show();
          self.$store.dispatch('deleteBlockNumbers', {
                id: self.block_numbers[idx].id
              })
              .then(() => {
                self.$f7.preloader.hide();
                self.getBlockNumbers();
              })
              .catch((err) => {
                self.$f7.preloader.hide();
                self.$f7.dialog.alert(err, 'LỖI!');
              })
        }
      });
    },
    changeAllConfig(type, name, value) {
      let real_region = this.region;
      if (this.playStyle === 'mb_ngan') {
        real_region = 'mb_ngan';
      }

      if (type === '2c') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }
      else if (type === '3c') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['3c'][name] = value;
          });
        });
      }
      else if (type === '4c') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['4c'][name] = value;
          });
        });
      }
      else if (type === 'da') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }
      else if (type === 'dx') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }
    },
    changeDetailConfig(channel_type, type, name, value) {
      let real_region = this.region;
      if (this.playStyle === 'mb_ngan') {
        real_region = 'mb_ngan';
      }

      if (type === '2c' && channel_type.indexOf('_') < 0) {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (this.filter_channel_options[real_region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === '3c') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (this.filter_channel_options[real_region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[real_region][datename][cn]['3c'][name] = value;
            }
          });
        });
      }
      else if (type === '4c') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (this.filter_channel_options[real_region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[real_region][datename][cn]['4c'][name] = value;
            }
          });
        });
      }
      else if (type === 'da') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (this.filter_channel_options[real_region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === 'dx') {
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (this.filter_channel_options[real_region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === '2c' && channel_type.indexOf('_') >= 0) {
        let type_cns = channel_type.split('_');
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if (cn.indexOf('_') >= 0) {
              let cn1 = this.filter_channel_options[real_region][datename][type_cns[0]];
              let cn2 = this.filter_channel_options[real_region][datename][type_cns[1]];

              let cns = cn.split('_');
              if (cn1 === cns[0] && cn2 === cns[1]) {
                this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
              }
            }
          });
        });
      }
    },
    changeTypeInputConfig() {
      let self = this;

      if (this.region === 'mn') {
        this.selected_customer.config_ui.type_input_over_config_mn = this.type_input_over_config;
      }
      else if (this.region === 'mt') {
        this.selected_customer.config_ui.type_input_over_config_mt = this.type_input_over_config;
      }
      else if (this.region === 'mb') {
        this.selected_customer.config_ui.type_input_over_config_mb = this.type_input_over_config;
      }
      else if (this.region === 'mb_ngan') {
        this.selected_customer.config_ui.type_input_over_config_mb = this.type_input_over_config;
      }

      this.$store.dispatch('changeCustomerUIConfig', {
        customer_id: self.custId,
        config_ui: self.selected_customer.config_ui
      }).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
    updateOverPointConfig() {
      let real_region = this.region;
      if (this.playStyle === 'mb_ngan') {
        real_region = 'mb_ngan';
      }

      if (this.type_input_over_config === 'all') {
        this.changeAllConfig('2c', 'over_point_dau', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_dau);
        this.changeAllConfig('2c', 'over_point_duoi', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_duoi);
        this.changeAllConfig('2c', 'over_point_bao', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_bao);
        this.changeAllConfig('2c', 'over_point_baylo', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_baylo);
        this.changeAllConfig('2c', 'over_point_tamlo', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_tamlo);
        this.changeAllConfig('da', 'over_point_da', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_da);
        this.changeAllConfig('dx', 'over_point_dx', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['2c'].over_point_dx);

        if (real_region === 'mb') {
          this.changeAllConfig('dx', 'over_point_dx_2', this.over_point_config.general_overpoint[real_region][this.detail_tab]['mb']['2c'].over_point_dx_2);
          this.changeAllConfig('dx', 'over_point_dx_3', this.over_point_config.general_overpoint[real_region][this.detail_tab]['mb']['2c'].over_point_dx_3);
          this.changeAllConfig('dx', 'over_point_dx_4', this.over_point_config.general_overpoint[real_region][this.detail_tab]['mb']['2c'].over_point_dx_4);
        }
        this.changeAllConfig('3c', 'over_point_dau', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['3c'].over_point_dau);
        this.changeAllConfig('3c', 'over_point_duoi', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['3c'].over_point_duoi);
        this.changeAllConfig('3c', 'over_point_bao', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['3c'].over_point_bao);
        this.changeAllConfig('3c', 'over_point_baylo', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['3c'].over_point_baylo);
        this.changeAllConfig('4c', 'over_point_bao', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['4c'].over_point_bao);
        this.changeAllConfig('4c', 'over_point_baylo', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['4c'].over_point_baylo);
        this.changeAllConfig('4c', 'over_point_duoi', this.over_point_config.general_overpoint[real_region][this.detail_tab][this.first_channel]['4c'].over_point_duoi);
      }

      this.$f7.dialog.preloader();

      this.$store.dispatch('changeCustomerConfig', {
        customer_id: this.custId,
        over_point_config: this.over_point_config.general_overpoint
      }).then(() => {
        this.$f7.dialog.close();
        this.changeTypeInputConfig();
        this.$emit('updatedConfig');
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    }
  },
  mounted() {
    if (this.region === 'mn') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mn;
    }
    else if (this.region === 'mt') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mt;
    }
    else if (this.region === 'mb') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mb;
    }
    else if (this.region === 'mb_ngan') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mb;
    }

    this.detail_tab = this.$moment().format('dddd').toLowerCase();

    this.form_block_numbers.customer_id = this.custId;
    this.form_block_numbers.region = this.region;
    this.form_block_numbers.play_style = this.playStyle;
    this.form_block_numbers.week_day.push(this.$moment(this.selected_drawdate).format('dddd').toLowerCase());
  }
};
</script>
